module.exports = __webpack_public_path__ + "static/media/tttt.706f127c.png";